import { useStore } from 'react-redux';
import { veteranFields } from '../definitions/constants';

let formStore = null;

export const getFormData = () => formStore?.getState()?.form?.data;

export const getVeteranSsn = () =>
  getFormData()?.[veteranFields.parentObject]?.[veteranFields.ssn];

export const __setStoreForTesting = store => {
  formStore = store;
};

export default function VeteranSsnBridge() {
  formStore = useStore();
  return null;
}
